import classNames from 'classnames';

import { ASSIGNMENT_STATUS } from '../../../../../utils/constants';
import { getStudentFullName } from '../../utils';
import s from './SectionCardRow.module.css';
import {
  AssignmentLabelCell,
  DateCell,
  DueDateCell,
  MobileAssignmentLabelCell,
  ScoreCell,
  TimeSpentCell,
} from './TableCells';
import { Fragment } from 'react';

export const SectionCardRow = ({
  currentView,
  assignment,
  currentStudent,
  user,
  settings,
  // Display
  isTotal,
  isDropdownOpen,
  isMobile,
  // Route Params
  getLaunchUrl,
  handleLocalLaunch,
  hasStudentReport,
  getStudentReportLink,
}) => {
  if (assignment?.status === ASSIGNMENT_STATUS.UNASSIGNED) {
    return null;
  }

  const showPercentSetting = settings.find(
    (setting) => setting.key === 'showPercent',
  )?.value;
  const isShowPercent = showPercentSetting !== 'false';

  const studentFullName = getStudentFullName(currentStudent);

  if (isMobile) {
    return (
      <Fragment>
        <hr className={s.mobileTableRowDivider} />
        <div className={s.mobileTableRow} key={assignment.id}>
          <MobileAssignmentLabelCell
            assignment={assignment}
            user={user}
            getLaunchUrl={getLaunchUrl}
            handleLocalLaunch={handleLocalLaunch}
          />
          <ScoreCell
            isgCurrentView={currentView}
            studentFullName={studentFullName}
            assignment={assignment}
            settings={settings}
            user={user}
            getLaunchUrl={getLaunchUrl}
            getStudentReportLink={getStudentReportLink}
            hasStudentReport={hasStudentReport}
            showPercent={isShowPercent}
            showOutOf={true}
            isMobile
          />
        </div>
      </Fragment>
    );
  }

  return (
    <div
      className={classNames(s.tableRow, { [s.totalRow]: isTotal })}
      key={assignment.id}
      data-test-id="isg-category-row"
      role="row"
    >
      <AssignmentLabelCell
        assignment={assignment}
        user={user}
        getLaunchUrl={getLaunchUrl}
        handleLocalLaunch={handleLocalLaunch}
        isMobile={isMobile}
        isDropdownOpen={isDropdownOpen}
      />
      <ScoreCell
        isgCurrentView={currentView}
        studentFullName={studentFullName}
        assignment={assignment}
        settings={settings}
        user={user}
        getLaunchUrl={getLaunchUrl}
        getStudentReportLink={getStudentReportLink}
        hasStudentReport={hasStudentReport}
        showPercent={isShowPercent}
      />
      <DueDateCell assignment={assignment} />
      <DateCell date={assignment?.dateCompleted} hide={isTotal} />
      <TimeSpentCell assignment={assignment} />
    </div>
  );
};
